import classnames from 'classnames';
import noop from 'lodash/noop';
import { bool, func, node, oneOf, string } from 'prop-types';
import { Component } from 'react';

import ContentWrapper from '../layout/ContentWrapper';

export default class BetHeader extends Component {
  static propTypes = {
    children: node.isRequired,
    refHandler: func,
    className: string,
    fullWidth: bool,
    theme: oneOf(['atg', 'sport']).isRequired,
  };

  static defaultProps = {
    refHandler: noop,
    fullWidth: false,
  };

  render() {
    const { children, refHandler, className, fullWidth, theme } = this.props;
    return (
      <div
        className={classnames('bet-header', className, {
          'bet-header--full-width': fullWidth,
          'bet-header--atg': theme === 'atg',
          'bet-header--sport': theme === 'sport',
        })}
        ref={refHandler}
      >
        {fullWidth ? (
          children
        ) : (
          <ContentWrapper className="bet-header__content-wrapper">
            {children}
          </ContentWrapper>
        )}
      </div>
    );
  }
}
